<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { compare } from '../helpers/textDiffHelper';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  message: {
    type: Object,
    required: true,
  },
  isActive: {
    type: Boolean,
    required: false,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);

const knowledge = useMapGetter('wgptBotKnowledgeManager/getKnowledge');

const diffArray = computed(() => {
  const original = knowledge.value || '';
  const current = props.message.content?.content || '';
  return compare(original, current);
});

const insertions = computed(() => {
  const count = diffArray.value.filter(([op]) => op === 1).length;
  if (count === 0) return null;
  return `+${count}`;
});

const deletions = computed(() => {
  const count = diffArray.value.filter(([op]) => op === -1).length;
  if (count === 0) return null;
  return `-${count}`;
});

const handleClick = () => {
  if (props.isDisabled) return;
  emit('click');
};
</script>

<template>
  <div class="flex justify-center">
    <div
      class="cursor-pointer bg-n-alpha-1 max-w-lg px-3 py-1 rounded-xl flex min-w-0 items-center gap-1 v-popper--has-tooltip text-xs font-medium disabled:cursor-not-allowed"
      :class="{
        'outline outline-1 outline-n-brand': isActive,
        '!cursor-default': isDisabled,
      }"
      @click="handleClick"
    >
      <span class="text-n-slate-11">{{ label }}</span>
      <span v-if="insertions" class="text-n-teal-10">{{ insertions }}</span>
      <span v-if="deletions" class="text-n-ruby-10">{{ deletions }}</span>
    </div>
  </div>
</template>
